export default __webpack_public_path__ + "static/media/Beard_5_C3.70095324.svg";